var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "multipleLikeButton", on: { click: _vm.toggle } },
    [
      _c("i", {
        staticClass: "icon",
        class: { bookmark: _vm.checked, "bookmark outline": !_vm.checked },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [_vm._v("保存")]),
      _vm._v(" "),
      _vm.$root.selectedShopCount
        ? _c("div", { staticClass: "ui floating circular label" }, [
            _vm._v(_vm._s(_vm.$root.selectedShopCount)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }